import useApi from "@/composables/useApi";
import { debounce } from "lodash";

export default function usePlanManagement() {
    const {fetchResource, updateResource} = useApi()

    const data = () => ({
        plans: [],
        years: [],
    })

    const updateYearlyValue = debounce((plan, type, year, newValue) => {
        updateResource(`/v2/finance-and-productivity/plan-management/${plan.id}/yearly-data`, {
            year: year,
            type: type,
            value: newValue,
        });
    }, 400)

    const methods = {
        async fetchData() {
            const response = await fetchResource('/v2/finance-and-productivity/plan-management/yearly-data')
            this.plans = response.plans
            this.years = response.years
        },

        handleYearlyValueChange(plan, type, year, newValue) {
            plan[type][year] = newValue;
            updateYearlyValue(plan, type, year, newValue);
        },
    }

    return {
        data,
        methods,
    }
}
